import React, { forwardRef } from 'react';
import './OfferShareCard.css';

// Hidden card captured by html2canvas when the user downloads an offer image.
const OfferShareCard = forwardRef(({
  offer,
  offerImage,
  propertyTypes = [],
  userName = '',
  formatPrice,
  formatArea
}, ref) => {
  if (!offer) return null;

  const propertyLabel = propertyTypes.find(
    (type) => type.value === (offer.propertyType || offer.type)
  )?.label || '';

  return (
    <div style={{ position: 'fixed', top: '-9999px', left: '-9999px', zIndex: -1 }}>
      <div ref={ref} className="offer-share-card" dir="rtl">
        {offerImage && (
          <img
            className="offer-share-card__img"
            src={offerImage}
            alt={offer.title}
            crossOrigin="anonymous"
          />
        )}
        <div className="offer-share-card__body">
          <div className="offer-share-card__type">
            {propertyLabel}
            {' · '}
            {offer.offerType === 'sale' ? 'للبيع' : 'للإيجار'}
          </div>
          <div className="offer-share-card__title">{offer.title || 'عرض عقاري'}</div>
          <div className="offer-share-card__location">📍 {offer.city}{offer.district ? ` - ${offer.district}` : ''}</div>
          <div className="offer-share-card__price">{formatPrice(offer.price, 'SAR', { onRequest: offer.priceOnRequest })}</div>
          <div className="offer-share-card__specs">
            {offer.area > 0 && <span>📐 {formatArea(offer.area)}</span>}
            {offer.rooms > 0 && <span>🛏 {offer.rooms} غرف</span>}
            {offer.bathrooms > 0 && <span>🚿 {offer.bathrooms} حمامات</span>}
          </div>
        </div>
        <div className="offer-share-card__footer">
          <span className="offer-share-card__brand">Misk · مسك</span>
          <span className="offer-share-card__user">{userName}</span>
        </div>
      </div>
    </div>
  );
});

OfferShareCard.displayName = 'OfferShareCard';

export default OfferShareCard;
